"use client";

import React from "react";
import logo1 from "../../assets/images/LB_logo.jpeg"
import logo2 from "../../assets/images/dhg.webp"
import { Button } from "@relume_io/relume-ui";



export function Logo1() {
  return (
    <section id="relume" className="px-[5%] py-12 md:py-16 lg:py-20">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <h1 className="font-bold mx-auto mb-6 w-full max-w-lg text-center text-base font-bold leading-[1.2] md:mb-8 md:text-2xl md:leading-[1.2]">
        Unsere Vision: Ein sicheres digitales Deutschland        </h1>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 pb-2 pt-4 md:pt-2">
          <p className="text-lg">Cybersicherheit ist heute keine Option mehr, sondern eine Notwendigkeit. Unsere Experten sorgen dafür, dass Unternehmen ihre digitale Transformation ohne Angst vor Cyberangriffen vorantreiben können.</p>
          <p className="text-lg" ><Button className="border-none px-0 font-bold text-2xl" onClick={() => window.open("https://meetings-eu1.hubspot.com/matthias32/website", "_blank")}>📩</Button> Lassen Sie uns gemeinsam die Zukunft sicher gestalten – <Button className="border-none px-0 font-bold text-xl" onClick={() => window.open("https://meetings-eu1.hubspot.com/matthias32/website", "_blank")}>kontaktieren</Button>  Sie uns für eine unverbindliche Beratung!</p>
          {/* <img
            src={logo1}
            alt="Webflow logo 1"
            className="max-h-12 md:max-h-14"
          />
          <img
            src={logo2}
            alt="Relume logo 1"
            className="max-h-12 md:max-h-14"
          />
          <img
            src={logo1}
            alt="Webflow logo 2"
            className="max-h-12 md:max-h-14"
          />
          <img
            src={logo2}
            alt="Relume logo 2"
            className="max-h-12 md:max-h-14"
          /> */}
      
        </div>
      </div>
    </section>
  );
}
